import * as React from 'react'

function SvgUser(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 30 30" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 9a3 3 0 11-6 0 3 3 0 016 0zm3 0A6 6 0 116 9a6 6 0 0112 0zm1 15.447V25H5v-.553c.22-.642.783-2.005 1.855-3.203C7.932 20.042 9.509 19 12 19c2.49 0 4.068 1.042 5.145 2.244 1.072 1.198 1.635 2.561 1.855 3.203zM22 26c0 1.105-.893 2-1.998 2H3.997A1.998 1.998 0 012 26v-1.63c0-.246.03-.49.105-.723C2.604 22.1 5.015 16 12 16c6.986 0 9.396 6.1 9.895 7.647.076.233.105.477.105.722V26zm-3.286-11.007A8.966 8.966 0 0021 9a8.966 8.966 0 00-2.286-5.993 6 6 0 110 11.987zM26.01 28h-1.425c.268-.613.416-1.29.416-2v-1.63c0-.48-.057-1.047-.25-1.644-.313-.97-1.203-3.326-3.134-5.483-.189-.21-.387-.419-.595-.623 4.748 1.59 6.46 5.784 6.873 7.027.077.233.106.477.106.722V26c0 1.105-.887 2-1.991 2z"
        fill="currentColor"
      />
    </svg>
  )
}

export default SvgUser
